"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRightButton = exports.createLeftButton = void 0;
function createLeftButton(leftIconId) {
    const picker = document.getElementById(leftIconId);
    const buttonLeft = picker.getElementsByClassName('calendar-navigation button-left');
    if (buttonLeft[0])
        buttonLeft[0].setAttribute('hidden', 'true');
}
exports.createLeftButton = createLeftButton;
function createRightButton(rightIconId) {
    const picker = document.getElementById(rightIconId);
    const buttonRight = picker.getElementsByClassName('calendar-navigation button-right');
    if (buttonRight[0])
        buttonRight[0].setAttribute('hidden', 'true');
}
exports.createRightButton = createRightButton;
//# sourceMappingURL=helperCreateElement.js.map